import OtherWork from "../../../../../../packages/gatsby-theme-marketing/src/components/otherWork";
import AboutSectionMDX from "../../../../../../packages/gatsby-theme-marketing/src/data/about";
import { Link as GatsbyLink } from 'gatsby';
import * as React from 'react';
export default {
  OtherWork,
  AboutSectionMDX,
  GatsbyLink,
  React
};